import React from 'react';
import EqualHeightComponent from '@bbkPricingPage/components/equal-height-component/equal-height-component';
import { getFormattedAmount } from '@bbkPricingPage/lib/currencies';

type PlanRenewalTextProps = {
  showPriceRenewal: boolean;
  text: string | undefined;
  price: number;
  currency: string;
  ignoreEqualHeight?: boolean;
};

export const PlanRenewalText: React.FC<PlanRenewalTextProps> = ({
  showPriceRenewal,
  text,
  price,
  currency,
  ignoreEqualHeight,
}) => {
  const shouldShow = text && showPriceRenewal;
  const data = {
    price: getFormattedAmount(price, currency),
  };
  const displayText = text?.replace('{{price}}', data.price);

  return (
    <EqualHeightComponent
      groupId="dynamic-height-pricing-card-price-renewal-text"
      ignore={ignoreEqualHeight}
    >
      {shouldShow ? (
        <div className="tw-mt-0">
          <div className="tw-text-center tw-text-sm tw-font-semibold tw-text-[var(--pricing-page-text-font-text-color)]">
            {displayText} <span className="font-bold"></span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </EqualHeightComponent>
  );
};
